// extracted by mini-css-extract-plugin
module.exports = {"body":"layout-module--body--w11mk","container":"layout-module--container--2TGku","content":"layout-module--content--3nIku"};